export class IntegrationConfig {
    'id';
    'projectId';
    'name';
    'enabled';
    'type';
    'config';
    'dateCreated';
    'dateModified';
    'userCreated';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "IntegType",
            "format": ""
        },
        {
            "name": "config",
            "baseName": "config",
            "type": "IntegConfig",
            "format": ""
        },
        {
            "name": "dateCreated",
            "baseName": "dateCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dateModified",
            "baseName": "dateModified",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "userCreated",
            "baseName": "userCreated",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
